import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=3f045cf5&scoped=true&lang=pug"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style0 from "./Editor.styl?vue&type=style&index=0&id=3f045cf5&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f045cf5",
  null
  
)

export default component.exports